// src/Redux/selectors/bmiHistorySelectors.js
export const selectBmiHistory = (state) => state.bmiHistory;
export const selectBmiHistoryData = (state) => state.bmiHistory.data;
export const selectBmiHistoryLoading = (state) => state.bmiHistory.loading;
export const selectBmiHistoryError = (state) => state.bmiHistory.error;
export const selectBmiHistoryHasFetched = (state) =>
  state.bmiHistory.hasFetched;
